<p-table
  [first]="first"
  [value]="orders"
  [rows]="rows"
  [paginator]="true"
  [loading]="loadingData"
  (onLazyLoad)="dataPrimeTable($event)"
  [lazy]="true"
  [totalRecords]="totalRows"
  [rowsPerPageOptions]="[10, 25, 50]"
  dataKey="id"
  styleClass="p-datatable-striped p-datatable-sm"
  [tableStyle]="{ 'min-width': '15rem' }"
  responsiveLayout="stack"
  currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} resultados"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">
      Cotizaciones
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 7%">Fecha</th>
      <th style="width: 7%">Folio</th>
      <th style="width: 5%">Total</th>
      <th style="width: 7%">Tipo de entrega</th>
      <th style="width: 5%">Vendedor</th>
      <th style="width: 10%">Acciones</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-order>
    <tr
      class="justify-content-center gap-3"
      [ngClass]="{
        'border-gray-400 border-bottom-1': isMobile
      }"
    >
      <td
        [ngClass]="{
          'hidden p-0': !order.updatedAt,
          'p-1 border-bottom-1 border-solid border-gray-200': order.updatedAt
        }"
      >
        <div class="p-column-title">Fecha</div>
        <div class="md:col-12 col-6 p-0">
          {{ order.updatedAt | date : 'dd-MM-yyyy HH:mm' }}
        </div>
      </td>
      <td
        [ngClass]="{
          'invisible-content p-0': !order.salesId,
          'p-1 border-bottom-1 border-solid border-gray-200': order.salesId
        }"
      >
        <div class="p-column-title">Folio</div>
        <div class="md:col-12 col-6 p-0">
          {{ order.salesId }}
        </div>
      </td>
      <td
        [ngClass]="{
          'hidden p-0': !order.total,
          'p-1 border-bottom-1 border-solid border-gray-200': order.total
        }"
      >
        <div class="p-column-title">Total</div>
        <div class="md:col-12 col-6 p-0">
          {{ order.total | currency }}
        </div>
      </td>
      <td
        [ngClass]="{
          'hidden p-0': !order.deliveryMode,
          'p-1 border-bottom-1 border-solid border-gray-200':
            order.deliveryMode
        }"
      >
        <div class="p-column-title">Tipo de entrega</div>
        <div class="md:col-12 col-6 p-0">
          {{
            order.deliveryMode === 'pickup'
              ? 'Retiro Tienda'
              : order.deliveryMode === 'delivery'
              ? 'Despacho Domicilio'
              : order.deliveryMode === 'pickup_now'
              ? 'Entrega Inmediata'
              : ''
          }}
        </div>
      </td>
      <td
        [ngClass]="{
          'invisible-content p-0': !order.vendedor,
          'p-1 border-bottom-1 border-solid border-gray-200': order.vendedor
        }"
      >
        <div class="p-column-title" style="margin-left: 5px; margin-top: 3px">
          Vendedor
        </div>
        <div
          class="md:col-12 col-6 p-0"
          style="margin-left: 5px; margin-top: 3px"
        >
          {{ order.vendedor ? order.vendedor : 'Web' }}
        </div>
      </td>
      <td
        class="justify-content-center gap-3 p-1 border-top-1 border-solid border-gray-200"
      >
        <a
          pTooltip="Descargar archivo en PDF"
          tooltipPosition="bottom"
          tooltipEvent="hover"
          style="margin-right: 20px"
          target="_blank"
          routerLink="/carro-compra/downloadpdf"
          [queryParams]="{ numero: order?.salesId }"
        >
          <i class="pi pi-file"></i>
        </a>
        <button
          pButton
          pTooltip="Añadir al carrito..."
          tooltipPosition="bottom"
          tooltipEvent="hover"
          icon="pi pi-cart-plus"
          class="p-button-sm p-button-info"
          (click)="convertirACarro(order)"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="no-data-available">
        No hay registros a mostrar!
      </td>
    </tr>
  </ng-template>
</p-table>
